import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { IFile } from 'src/model';
import { ProjectCardPropositionFileItem } from './ProjectPropositionCardFileItem';

interface IProjectPropositionCardFilesProps {
  files: IFile[];
  propositionId: string;
}

export const ProjectPropositionCardFiles: React.SFC<
  IProjectPropositionCardFilesProps
> = ({ files, propositionId }) => (
  <Row
    className='position-absolute bg-secondary w-100 p-2'
    style={{ borderRadius: '0 0 0.5rem 0.5rem', bottom: 0 }}
  >
    {files.map((file: IFile) => (
      <Col xs='6'>
        <ProjectCardPropositionFileItem
          file={file}
          propositionId={propositionId}
        />
      </Col>
    ))}
  </Row>
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectPropositions/ProjectPropositionCard/ProjectPropositionCardFiles.tsx